import * as React from "react";
import { useContext } from "react";
import moment from "moment";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { DropdownButton, MenuItem } from "components/bootstrap";
import DrilldownContext from "views/components/contexts/DrilldownContext";
import SearchLink from "views/logic/search/SearchLink";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { getPathnameWithoutId } from "util/URLUtils";
import useLocation from "routing/useLocation";
import useSearchConfiguration from "hooks/useSearchConfiguration";
const buildTimeRangeOptions = (searchConfig) => {
  var _a;
  const surroundingTimerangeOptions = (_a = searchConfig == null ? void 0 : searchConfig.surrounding_timerange_options) != null ? _a : {};
  return Object.fromEntries(
    Object.entries(surroundingTimerangeOptions).map(([key, value]) => [moment.duration(key).asSeconds(), value])
  );
};
const buildFilterFields = (messageFields, searchConfig) => {
  var _a;
  const surroundingFilterFields = (_a = searchConfig == null ? void 0 : searchConfig.surrounding_filter_fields) != null ? _a : [];
  return Object.fromEntries(surroundingFilterFields.map((fieldName) => [fieldName, messageFields[fieldName]]));
};
const buildSearchLink = (id, from, to, filterFields, streams, streamCategories) => SearchLink.builder().timerange({ type: "absolute", from, to }).streams(streams).streamCategories(streamCategories).filterFields(filterFields).highlightedMessage(id).build().toURL();
const searchLink = (range, timestamp, id, messageFields, searchConfig, streams, streamCategories) => {
  const fromTime = moment(timestamp).subtract(Number(range), "seconds").toISOString();
  const toTime = moment(timestamp).add(Number(range), "seconds").toISOString();
  const filterFields = buildFilterFields(messageFields, searchConfig);
  return buildSearchLink(id, fromTime, toTime, filterFields, streams, streamCategories);
};
const SurroundingSearchButton = ({ timestamp, id, messageFields }) => {
  const { streams, streamCategories } = useContext(DrilldownContext);
  const { config: searchConfig, isInitialLoading: isLoadingSearchConfig } = useSearchConfiguration();
  const timeRangeOptions = buildTimeRangeOptions(searchConfig);
  const location = useLocation();
  const sendTelemetry = useSendTelemetry();
  const sendEvent = (range) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_MESSAGE_TABLE_SHOW_SURROUNDING_MESSAGE, {
      app_pathname: getPathnameWithoutId(location.pathname),
      app_section: "search-message-table",
      app_action_value: "seach-message-table-show-surrounding",
      event_details: {
        range
      }
    });
  };
  const menuItems = Object.keys(timeRangeOptions).sort((a, b) => naturalSort(a, b)).map((range) => /* @__PURE__ */ React.createElement(
    MenuItem,
    {
      key: range,
      onClick: () => sendEvent(range),
      href: searchLink(range, timestamp, id, messageFields, searchConfig, streams, streamCategories),
      target: "_blank",
      rel: "noopener noreferrer"
    },
    timeRangeOptions[range]
  ));
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      title: "Show surrounding messages",
      bsSize: "small",
      id: "surrounding-search-dropdown",
      disabled: isLoadingSearchConfig
    },
    menuItems
  );
};
export default SurroundingSearchButton;
